var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('@rtm-ui/tracker'), require('@rtm-ui/theme')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', '@rtm-ui/tracker', '@rtm-ui/theme'], factory) : (global = global || self, factory(global.bootstrap = {}, global.React, global.PropTypes, global.RtmUiTracker, global.RtmUiTheme));
})(this, function (exports, React, PropTypes, tracker, theme) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;

  var ErrorBoundary =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
      var _this;

      _classCallCheck(this, ErrorBoundary);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorBoundary).call(this, props));
      _this.state = {
        hasError: false
      };
      return _this;
    }

    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        if (this.props.onError) {
          this.props.onError();
        } // FIXME: Log this somewhere


        console.error(error, errorInfo);
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          return (
            /*#__PURE__*/
            React.createElement("div", null, "We're sorry, something went wrong. Please try again.")
          );
        }

        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        return {
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(React.Component);

  var Bootstrap = function Bootstrap(_ref) {
    var overrides = _ref.overrides,
        children = _ref.children,
        _ref$trackingData = _ref.trackingData,
        trackingData = _ref$trackingData === void 0 ? {
      category: 'default'
    } : _ref$trackingData,
        cssReset = _ref.cssReset,
        props = _objectWithoutProperties(_ref, ["overrides", "children", "trackingData", "cssReset"]);

    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        useDefaultTheme = _React$useState2[0],
        setUseDefaultTheme = _React$useState2[1];

    var Tracking = props.trackingProvider ? props.trackingProvider : tracker.TrackingProvider;
    var theme$1 = theme.themeMap[props.themeName || trackingData.brand];
    var themeWithOverrides = overrides ? Object.keys(overrides).reduce(function (acc, cv, ci) {
      return theme.setIn(acc, cv, Object.values(overrides)[ci]);
    }, theme$1) : theme$1;
    return (
      /*#__PURE__*/
      React.createElement(ErrorBoundary, {
        onError: setUseDefaultTheme
      },
      /*#__PURE__*/
      React.createElement(Tracking, {
        trackingData: trackingData
      },
      /*#__PURE__*/
      React.createElement(theme.BootstrapTheme, {
        useDefaultTheme: useDefaultTheme,
        theme: themeWithOverrides,
        cssReset: cssReset
      }, children)))
    );
  };

  Bootstrap.propTypes = {
    children: PropTypes.node.isRequired,
    trackingData: PropTypes.shape({
      brand: PropTypes.string
    }),
    trackingProvider: PropTypes.func
  };
  exports.Bootstrap = Bootstrap;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});